import React from 'react';
import { ProgressIndicator } from '../../progressIndicator/progressIndicator';

type MatchRankProps = {
  percentage: number;
  radius?: number;
  strokeWidth?: number;
  overrideText?: string;
  strokeFill?: string;
  fontSize?: number;
  fill?: string;
};

export const scaleColors = {
  weakLevel: '#E7DB2C',
  midLevel: '#92D848',
  maxLevel: '#2A9A47',
};

// TODO - add animation?
const MatchRank: React.FC<MatchRankProps> = ({
  percentage,
  overrideText,
  radius = 40,
  strokeWidth = 8,
  strokeFill = 'transparent',
  fontSize,
  fill = '#F5F5F5',
}) => {
  let color = scaleColors.weakLevel;
  if (percentage > 50) color = scaleColors.midLevel;
  if (percentage > 80) color = scaleColors.maxLevel;

  const progressPercent = percentage;
  const normalizedRadius = radius - strokeWidth;
  const circumference = normalizedRadius * 2 * Math.PI;

  const strokeDashOffset =
    circumference - (progressPercent / 100) * circumference;

  return (
    <div className="MatchRank">
      <svg height={radius * 2} width={radius * 2}>
        <circle
          className="BackgroundCircle"
          strokeWidth={strokeWidth}
          fill="transparent"
          r={normalizedRadius}
          cx={radius}
          cy={radius}
          stroke={fill ? fill : 'transparent'}
        />
      </svg>
      <svg
        className="Bar"
        height={radius * 2}
        width={radius * 2}
        style={{ transform: 'rotate(-90deg)' }}
      >
        <circle
          className="ProgressCircle"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference + ' ' + circumference}
          fill={strokeFill}
          style={{ strokeDashoffset: strokeDashOffset }}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
      </svg>
      <p
        className="InnerText"
        style={
          fontSize
            ? {
                fontSize: `${fontSize}rem`,
              }
            : {}
        }
      >
        {overrideText ? (
          <div className="MatchRankOverrideText">{overrideText}</div>
        ) : (
          <>
            {progressPercent}
            <sup>%</sup>
          </>
        )}
      </p>
    </div>
  );
};

export default MatchRank;
